import React from "react";
import { Box, Paper, Typography, Zoom } from "@mui/material";
import { CheckCircleOutline as CheckIcon } from "@mui/icons-material";

const SuccessStep = ({ minHeight }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 4,
        mb: 3,
        borderRadius: 2,
        border: "1px solid #eaeaea",
        backgroundColor: "#fff",
        minHeight,
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        marginBottom: 0,
      }}
    >
      <Zoom in timeout={300}>
        <Box sx={{ mb: 2 }}>
          <CheckIcon
            sx={{
              fontSize: { xs: 48, sm: 56 },
              color: "#22c55e",
              filter: "drop-shadow(0 6px 16px rgba(34,197,94,0.35))",
            }}
          />
        </Box>
      </Zoom>

      <Typography
        variant="h6"
        sx={{ fontWeight: 700, mb: 0.5, fontSize: "1.5rem" }}
      >
        Success! The event was completed.
      </Typography>

      <Typography
        variant="body2"
        sx={{ color: "text.secondary", mb: 3, fontSize: "1.25rem" }}
      >
        Your customer import was submitted successfully.
      </Typography>
    </Paper>
  );
};

export default SuccessStep;
